// import React from 'react';
// import { Link } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import { FileText, Search, Shield, Zap, Database, TrendingUp } from 'lucide-react';

// const Home = () => {
//   const features = [
//     {
//       icon: <Shield size={32} />,
//       title: 'Blockchain Secured',
//       description: 'All records stored securely on Polygon blockchain with immutable proof',
//     },
//     {
//       icon: <Database size={32} />,
//       title: 'IPFS Storage',
//       description: 'Documents stored on decentralized IPFS network via Pinata',
//     },
//     {
//       icon: <Zap size={32} />,
//       title: 'Fast & Affordable',
//       description: 'Lightning-fast transactions with minimal gas fees (~$0.01-0.05)',
//     },
//     {
//       icon: <TrendingUp size={32} />,
//       title: 'Easy Management',
//       description: 'Simple interface for adding, searching, and exporting invoice records',
//     },
//   ];

//   return (
//     <div className="home-page">
//       <motion.div
//         className="hero-section"
//         initial={{ opacity: 0, y: 30 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.6 }}
//       >
//         <div className="hero-content">
//           <motion.h1
//             className="hero-title"
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.2 }}
//           >
//             Corporate Tally Registry
//           </motion.h1>

//           <motion.p
//             className="hero-subtitle"
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.3 }}
//           >
//             Invoice authenticity and verification for businesses that need trust
//           </motion.p>

//           <motion.div
//             className="hero-buttons"
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.4 }}
//           >
//             <Link to="/add-invoice" className="hero-button primary">
//               <FileText size={20} />
//               <span>Add New Invoice</span>
//             </Link>
//             <Link to="/search" className="hero-button secondary">
//               <Search size={20} />
//               <span>Search Records</span>
//             </Link>
//           </motion.div>
//         </div>
//       </motion.div>

//       <motion.div
//         className="features-section"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ delay: 0.6 }}
//       >
//         <h2 className="features-title">Why Choose Our Platform?</h2>
//         <div className="features-grid">
//           {features.map((feature, index) => (
//             <motion.div
//               key={index}
//               className="feature-card"
//               initial={{ opacity: 0, y: 30 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.7 + index * 0.1 }}
//               whileHover={{ y: -8, scale: 1.02 }}
//             >
//               <div className="feature-icon">{feature.icon}</div>
//               <h3 className="feature-title">{feature.title}</h3>
//               <p className="feature-description">{feature.description}</p>
//             </motion.div>
//           ))}
//         </div>
//       </motion.div>

//       <style jsx="true">{`
//         .home-page {
//           min-height: calc(100vh - 80px);
//           padding: 40px 24px;
//         }

//         .hero-section {
//           max-width: 1200px;
//           margin: 0 auto 80px;
//           text-align: center;
//         }

//         .hero-content {
//           background: rgba(255, 255, 255, 0.98);
//           backdrop-filter: blur(10px);
//           border-radius: 32px;
//           padding: 80px 40px;
//           box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
//         }

//         .hero-title {
//           font-size: 56px;
//           font-weight: 800;
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//           background-clip: text;
//           margin-bottom: 24px;
//           line-height: 1.2;
//         }

//         .hero-subtitle {
//           font-size: 20px;
//           color: #64748b;
//           max-width: 600px;
//           margin: 0 auto 48px;
//           line-height: 1.6;
//         }

//         .hero-buttons {
//           display: flex;
//           gap: 16px;
//           justify-content: center;
//           flex-wrap: wrap;
//         }

//         .hero-button {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           padding: 16px 32px;
//           border-radius: 12px;
//           font-size: 16px;
//           font-weight: 600;
//           text-decoration: none;
//           transition: all 0.3s ease;
//         }

//         .hero-button.primary {
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           color: white;
//           box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
//         }

//         .hero-button.primary:hover {
//           transform: translateY(-4px);
//           box-shadow: 0 15px 40px rgba(102, 126, 234, 0.4);
//         }

//         .hero-button.secondary {
//           background: white;
//           color: #667eea;
//           border: 2px solid #667eea;
//         }

//         .hero-button.secondary:hover {
//           background: #667eea;
//           color: white;
//           transform: translateY(-4px);
//         }

//         .features-section {
//           max-width: 1200px;
//           margin: 0 auto;
//         }

//         .features-title {
//           text-align: center;
//           font-size: 40px;
//           font-weight: 700;
//           color: white;
//           margin-bottom: 48px;
//           text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
//         }

//         .features-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//           gap: 24px;
//         }

//         .feature-card {
//           background: white;
//           border-radius: 20px;
//           padding: 40px;
//           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//           transition: all 0.3s ease;
//         }

//         .feature-icon {
//           width: 64px;
//           height: 64px;
//           border-radius: 16px;
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin-bottom: 20px;
//         }

//         .feature-title {
//           font-size: 22px;
//           font-weight: 700;
//           color: #1e293b;
//           margin-bottom: 12px;
//         }

//         .feature-description {
//           font-size: 15px;
//           color: #64748b;
//           line-height: 1.6;
//         }

//         @media (max-width: 768px) {
//           .hero-content {
//             padding: 60px 24px;
//           }

//           .hero-title {
//             font-size: 36px;
//           }

//           .hero-subtitle {
//             font-size: 16px;
//           }

//           .hero-buttons {
//             flex-direction: column;
//           }

//           .hero-button {
//             width: 100%;
//             justify-content: center;
//           }

//           .features-title {
//             font-size: 28px;
//           }

//           .features-grid {
//             grid-template-columns: 1fr;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default Home;
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FileText,
  Search,
  Shield,
  Zap,
  Database,
  TrendingUp,
} from "lucide-react";

const Home = () => {
  const features = [
    {
      icon: <Shield size={32} />,
      title: "Blockchain Secured",
      description:
        "All records stored securely on Polygon blockchain with immutable proof",
    },
    {
      icon: <Database size={32} />,
      title: "IPFS Storage",
      description: "Documents stored on decentralized IPFS network via Pinata",
    },
    {
      icon: <Zap size={32} />,
      title: "Fast & Affordable",
      description:
        "Lightning-fast transactions with minimal gas fees (~$0.01-0.05)",
    },
    {
      icon: <TrendingUp size={32} />,
      title: "Easy Management",
      description:
        "Simple interface for adding, searching, and exporting invoice records",
    },
  ];

  return (
    <div className="home-page">
      <motion.div
        className="hero-section"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="hero-content">
          <motion.h1
            className="hero-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            Corporate Tally Registry
          </motion.h1>

          <motion.p
            className="hero-subtitle"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            Blockchain-powered invoice management system with decentralized
            document storage
          </motion.p>

          <motion.div
            className="hero-buttons"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            <Link to="/add-invoice" className="hero-button primary">
              <FileText size={20} />
              <span>Add New Invoice</span>
            </Link>
            <Link to="/search" className="hero-button secondary">
              <Search size={20} />
              <span>Search Records</span>
            </Link>
          </motion.div>
        </div>
      </motion.div>

      <motion.div
        className="features-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
      >
        <h2 className="features-title">Why Choose Our Platform?</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="feature-card"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.7 + index * 0.1 }}
              whileHover={{ y: -8, scale: 1.02 }}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>

      {/* ✅ NEW: Footer */}
      <motion.footer
        className="home-footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
      >
        <p className="copyright">
          ©{" "}
          <a href="https://quantrixe.net" target="_blank">
            Quantrixe
          </a>
          , 2025, email: mitunshil747@gmail.com
        </p>
      </motion.footer>

      <style jsx="true">{`
        .home-page {
          min-height: calc(100vh - 80px);
          padding: 40px 24px;
          display: flex;
          flex-direction: column;
        }

        .hero-section {
          max-width: 1200px;
          margin: 0 auto 80px;
          text-align: center;
        }

        .hero-content {
          background: rgba(255, 255, 255, 0.98);
          backdrop-filter: blur(10px);
          border-radius: 32px;
          padding: 80px 40px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
        }

        .hero-title {
          font-size: 56px;
          font-weight: 800;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 24px;
          line-height: 1.2;
        }

        .hero-subtitle {
          font-size: 20px;
          color: #64748b;
          max-width: 600px;
          margin: 0 auto 48px;
          line-height: 1.6;
        }

        .hero-buttons {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .hero-button {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 16px 32px;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .hero-button.primary {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
        }

        .hero-button.primary:hover {
          transform: translateY(-4px);
          box-shadow: 0 15px 40px rgba(102, 126, 234, 0.4);
        }

        .hero-button.secondary {
          background: white;
          color: #667eea;
          border: 2px solid #667eea;
        }

        .hero-button.secondary:hover {
          background: #667eea;
          color: white;
          transform: translateY(-4px);
        }

        .features-section {
          max-width: 1200px;
          margin: 0 auto;
          flex: 1;
        }

        .features-title {
          text-align: center;
          font-size: 40px;
          font-weight: 700;
          color: white;
          margin-bottom: 48px;
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        }

        /* ✅ UPDATED: Keep all 4 cards in same line */
        .features-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 24px;
        }

        .feature-card {
          background: white;
          border-radius: 20px;
          padding: 40px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }

        .feature-icon {
          width: 64px;
          height: 64px;
          border-radius: 16px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
        }

        .feature-title {
          font-size: 22px;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 12px;
        }

        .feature-description {
          font-size: 15px;
          color: #64748b;
          line-height: 1.6;
        }

        .home-footer {
          max-width: 1200px;
          margin: 60px auto 0;
          padding: 32px 0 24px;
          border-top: 1px solid rgba(255, 255, 255, 0.2);
          text-align: center;
        }

        .copyright {
          font-size: 17px;
          color: rgba(255, 255, 255, 0.8);
          font-weight: 500;
          letter-spacing: 0.5px;
        }

        /* ✅ UPDATED: Responsive breakpoints */
        @media (max-width: 1200px) {
          .features-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 768px) {
          .hero-content {
            padding: 60px 24px;
          }

          .hero-title {
            font-size: 36px;
          }

          .hero-subtitle {
            font-size: 16px;
          }

          .hero-buttons {
            flex-direction: column;
          }

          .hero-button {
            width: 100%;
            justify-content: center;
          }

          .features-title {
            font-size: 28px;
          }

          .features-grid {
            grid-template-columns: 1fr;
          }

          .home-footer {
            margin-top: 40px;
            padding: 24px 0 16px;
          }

          .copyright {
            font-size: 17px;
          }
        }
      `}</style>
    </div>
  );
};

export default Home;
